import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { LandingPage } from './pages/LandingPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import SupportPage from './pages/SupportPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#EA580C',
    },
    secondary: {
      main: '#1E3A5F',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/soporte" element={<SupportPage />} />
          <Route path="/contact" element={<SupportPage />} />
          <Route path="/contacto" element={<SupportPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
